export default __webpack_public_path__ + "static/media/addEcl.2ac21bbb.svg";